<app-nav></app-nav>
<section class="motorInsurance" *ngIf="!quotesDetailsTable && !motorProposalPageHdfc && !motorProposalPageGodigit">
  <app-click-to-call></app-click-to-call>
  <div class="container">
    <div class="col">
      <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
        <center class="top-gap-sm">
          <img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/motor-insurance/motor-insurance-main.jpg"
            class="img-responsive">
        </center>
        <center class="sub-title">
          <p>Get Quotes in less than 2 mins</p>
        </center>
        <div class="col sum-container">
          <p class="title">Type of Car</p>
          <div class="sum-insured-input">
            <div class="form-check-inline">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" name="typeOptions" value="New Business"
                  [(ngModel)]="typeOptions" (change)="onTypeChange($event.target.value)"><label>New</label>
                <!-- <input class="form-check-input" type="radio" value="New Business" [(ngModel)]="New Business.value" name="typeOptions" value="i" [checked]="true" (change)="onItemChange($event.target.value)"/> -->
              </label>
            </div>
            <div class="form-check-inline">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" name="typeOptions" value="Rollover"
                  [(ngModel)]="typeOptions" (change)="onTypeChange($event.target.value)"><label>Existing</label>
              </label>
            </div>
          </div>
          <p class="title mt-4">Manufacturer Name/Brand</p>
          <div class="sum-insured-input">
            <div class="form-group">
              <select class="form-control" name="manufacturerName" id="manufacturerName" [(ngModel)]="selectedOption"
                (change)="getKeyforManufaturer($event)" required>
                <option disabled selected>Select Model</option>
                <option value="{{list.value}}" [attr.key]="list.key" *ngFor="let list of listOfManufacturer">
                  {{list.value}}</option>
              </select>
            </div>
          </div>
          <p class="title mt-4">Car Model</p>
          <div class="sum-insured-input">
            <div class="form-group">
              <select class="form-control" name="carModel" id="carModel" [(ngModel)]="selectedModelOption"
                (change)="getKeyforModel($event)" required>
                <option disabled selected>Select Vehicle</option>
                <option value="{{list.value}}" [attr.key]="list.key" *ngFor="let list of listOfVehicle">{{list.value}}
                </option>
              </select>
            </div>
          </div>
          <p class="title mt-4">State</p>
          <div class="sum-insured-input">
            <div class="form-group">
              <select class="form-control" name="state" id="state" [(ngModel)]="state" (change)="getKeyforStates($event)" required>
                  <option disabled selected>Select State</option>  
                <option value="{{list.value}}" [attr.key]="list.key" *ngFor="let list of listOfStates">{{list.value}}</option>
              </select>
            </div>
          </div>
          <p class="title mt-4">RTO City</p>
          <div class="sum-insured-input">
            <div class="form-group">
              <select class="form-control" name="city" id="city" [(ngModel)]="city" (change)="getSelectedCity($event)" required>
                  <option disabled selected>Select City</option>
                  <option value="{{list.value}}" [attr.key]="list.key" *ngFor="let list of listOfCity">{{list.value}}</option>
              </select>
            </div>
          </div>
          <p  class="title mt-4">Pincode</p>
          <div  class="sum-insured-input">
            <div class="form-group">
              <input class="form-control" type="number" name="pincodeFirst" [(ngModel)]="pincodeFirst"
                (keydown.space)="$event.preventDefault();" (focusout)="goDigitPincodeValidate(pincodeFirst)"
                maxlength="6" minlength="6" id="pincodeFirst" #pinCode="ngModel"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                required>
              <div *ngIf="invalidPincode" class="error-message">
                Invalid pincode.
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Vehicle Registration Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input type="text"  name="vehicleRegNumOnLead" id="vehicleRegNumOnLead"
                    class="form-control" [(ngModel)]="vehicleRegNumLead" maxlength="100" #vehicleRegNumOnLead="ngModel" placeholder="Ex; HR26AC1234"
                    required>
                  <div *ngIf="vehicleRegNumOnLead.invalid && vehicleRegNumOnLead.touched" class="error-message">
                    <div *ngIf="vehicleRegNumOnLead.errors.required">
                      Vehicle Registration number is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Engine Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="engineNumberOnLead" id="engineNumberOnLead" #engineNumberOnLead="ngModel"
                    [(ngModel)]="engineNumberLead" minlength="5" maxlength="100" required>
                  <div *ngIf="engineNumberOnLead.invalid && engineNumberOnLead.touched " class="error-message">
                    <div *ngIf="engineNumberOnLead.errors.required">
                      Engine Number is required.
                    </div>
                    <div *ngIf="engineNumberOnLead.errors.minlength">
                      Engine number should contain atleast 5 characters.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Chasis Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="chasisNumberOnLead" id="chasisNumberOnLead" #chasisNumberOnLead="ngModel"
                    [(ngModel)]="chasisNumberLead" maxlength="100" required>
                  <div *ngIf="chasisNumberOnLead.invalid && chasisNumberOnLead.touched " class="error-message">
                    <div *ngIf="chasisNumberOnLead.errors.required">
                      Chasis Number is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Sub Insurance Product</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <select class="form-control long-text" id="subInsuranceOnlead" name="subInsurance"
                    [(ngModel)]="subInsuranceOnLead" id="subInsuranceOnlead" #subInsuranceOnlead="ngModel"
                    (change)="getSubInsurer($event)" required>
                    <!-- <option value="30">3 Year TP + 0 Year OD</option> -->
                    <option value="31">3 Year TP + 1 Year OD</option>
                    <option value="33">3 Year TP + 3 Year OD</option>
                  </select>
                  <div *ngIf="subInsuranceOnlead.invalid && subInsuranceOnlead.touched " class="error-message">
                    <div *ngIf="subInsuranceOnlead.errors.required">
                      Sub Insurance is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-12">
              <p class="title mendatory">Manufacturing Date</p>
              <div class="sum-insured-input reg-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img
                      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="manufaturingDateLead" #manufaturingDateOnLead
                      dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2200"
                      placeholder="Date" name="manufaturingDateOnLead" [minDate]="startDate" keepInvalid [required]="true">
                    </p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Manufaturing Date is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <p class="title mendatory">Purchasing Registration Date</p>
              <div class="sum-insured-input reg-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img
                      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="purchaseDateLead" #purchaseDateOnLead
                      dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2200"
                      placeholder="Date" name="purchaseDateOnLead" [maxDate]="purchaseDateLead" keepInvalid
                      [required]="true"></p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Purchase Date Date is required.
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="typeOptionsSection">
            <p class="title mt-4">Registration Date</p>
            <div class="sum-insured-input reg-date-input">
              <div class="input-group">
                <div class="input-group addon">
                  <img
                    src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                  <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder="Date" name="regDate"
                    [(ngModel)]="regDate" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                    yearRange="1960:2020" [maxDate]="currentDate" keepInvalid [required]="true"></p-calendar>
                  <span class="input-group-addon" id="basic-addon-dueDate"></span>
                </div>
              </div>
            </div>
            <p class="title mt-4">Previous Claim</p>
            <div class="sum-insured-input">
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" name="claimOpt" value="1" [(ngModel)]="claimOpt"
                    (change)="getPreviousClaim($event.target.value)">Yes
                </label>
              </div>
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" name="claimOpt" value="0" [(ngModel)]="claimOpt"
                    (change)="getPreviousClaim($event.target.value)">No
                </label>
              </div>
            </div>
            <div *ngIf="claimOpt">
              <p class="title mt-4">Previous NCB</p>
              <div class="sum-insured-input ncb-radio">
                <div class="form-check-inline col-3">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="ncbOpt" value="0"
                      [(ngModel)]="isPreviousDiscount" (change)="getPreviousNcb($event.target.value)">0%
                  </label>
                </div>
                <div class="form-check-inline col-3">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="ncbOpt" value="20"
                      [(ngModel)]="isPreviousDiscount" (change)="getPreviousNcb($event.target.value)">20%
                  </label>
                </div>
                <div class="form-check-inline col-3">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="ncbOpt" value="25"
                      [(ngModel)]="isPreviousDiscount" (change)="getPreviousNcb($event.target.value)">25%
                  </label>
                </div>
                <div class="form-check-inline col-3">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="ncbOpt" value="35"
                      [(ngModel)]="isPreviousDiscount" (change)="getPreviousNcb($event.target.value)">35%
                  </label>
                </div>
                <div class="form-check-inline col-3">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="ncbOpt" value="45"
                      [(ngModel)]="isPreviousDiscount" (change)="getPreviousNcb($event.target.value)">45%
                  </label>
                </div>
                <div class="form-check-inline col-3">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="ncbOpt" value="50"
                      [(ngModel)]="isPreviousDiscount" (change)="getPreviousNcb($event.target.value)">50%
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center top-gap-lg">
            <button class="btn btn-bordered-blue" [disabled]="f.form.invalid"  (click)="submitDetails()">Next</button>
            <!-- <button class="btn btn-bordered-blue"  *ngIf="environment.production" (click)="submitDetailsforProd()">Next</button> -->
          </div>
        </div>
      </form>
      <div class="col text-center top-gap-lg">
        <p>INSURERS</p>
        <div class="row insurer-logo">
          <!-- <div class="col text-center">
            <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/HDFC-ERGO.png">
          </div> -->
          <div class="col text-center">
            <img
              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/go-digit-insurance.png">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bar">
    <span><b><u>Fill Info</u></b></span><span class="next-step-icon"></span><span>Quote Page</span>
  </div>
</section>
<section class="motorInsurance-quote-details" *ngIf="quotesDetailsTable && !motorProposalPageHdfc">
  <div class="breadcrumbs text-center">
    <span routerLink="/home">Home</span>
    <span routerLink="/family-health-insurance">Motor Insurance</span>
    <span>Quote</span>
  </div>
  <div class="proposed-limit-section">
    <p class="heading">Proposed Quote</p>
    <p class="sub-heading">Insured Declared Value<span class="insuredAmount"> &#8377;
        {{goDigitData == null  ? 'NA' : goDigitIdvRange.minSumInsured}}</span></p>
  </div>
  <div class="quote-summary">
    <div class="insurer-logo">
      <span>Comprehensive</span>
      <div class="logo-links text-center">
        <input type="radio" class="form-check-input" name="insurerLogoBasic" value="goDigit"
          (change)="onInsurerSelect($event.target.value)" checked="checked"><img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/go-digit-insurance.png">
        <!-- <input type="radio" class="form-check-input" name="insurerLogoBasic" value="hdfc" (change)="onInsurerSelect($event.target.value)" checked="checked"><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/HDFC-ERGO.png"> -->
      </div>
      <span class="text-muted">Own Damage Cover + Third Party Liability</span>
    </div>
    <div class="premium-details">
      <div class="text-center">
        <div class="p-2 mr-auto">
          <span class="title">Total Premium</span>
          <span class="sub-title"> (INR,Excluding Taxes)</span>
        </div>
        <!-- <div class="p-2">
          <span class="rupees-symbol">&#8377;</span><span class="amount"></span>
        </div> -->
      </div>
      <div class="premium-amount row text-center mb-3">
        <div class="col">
          <!-- <span *ngIf="goDigitNotAvailable" class="amount">N/A</span> -->
          <span class="rupees-symbol">&#8377;</span><span
            class="amount">{{goDigitData == null ? 'NA' : goDigitPremium.option0}}</span>
        </div>
        <!-- Uncomment for enable HDFC -->
        <!-- <div class="col">
            <span  class="rupees-symbol">&#8377;</span><span class="amount">{{hdfcData == null ? 'NA' : hdfcPremium.option0}}</span>
            <span *ngIf="notAvailable"  class="amount">N/A</span>
          </div> -->
      </div>
      <div class="row">
        <div class="col">
          <div class="col p-2 d-flex text-center">
            <button class="btn-bordered-blue  mr-auto collapsed" data-toggle="collapse"
              data-target="#detailed-section-first">
              <span class="if-collapsed"></span>
            </button>
            <button class="btn-filled-orange pull-right" (click)="goToProposal(insurerValue, '0');">Buy
              Now</button>
          </div>
        </div>
      </div>
      <div id="detailed-section-first" class="collapse">
        <div class="quote-section">
          <div class="premium-summary p-2">
            <p class="title">
              Insured declared Value (IDV) <span class="insuredAmount"> &#8377;
                {{goDigitData == null  ? 'NA' : goDigitIdvRange.minSumInsured}} -
                {{goDigitData == null  ? 'NA' : goDigitIdvRange.maxSumInsured}}</span>
            </p>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <p class="title">Covers</p>
            </div>
            <div class="right-box">
              <span><b>Go Digit</b></span>
            </div>
            <!-- <div class="right-box">
              <span><b>HDFC ERGO</b></span>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Third Party Liability</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="right"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Own Damage Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="right"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Other Driver Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="right"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>PA Unnamed Person Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>PA Owner Driver Cover (Mandatory)</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <!-- <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No Co-Pay</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <div class="right-box">
                <icon class="cross"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No sub-limits on room rent</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <div class="right-box">
                <icon class="cross"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Lower waiting period for pre-existing diseases (i.e. less than 4 years)</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <div class="right-box">
                <icon class="cross"></icon>
            </div>
          </div> -->
          <hr>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <p class="title">Accessories</p>
            </div>
            <div class="right-box">
              <span><b>Go Digit</b></span>
            </div>
            <!-- <div class="right-box">
              <span><b>HDFC ERGO</b></span>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Electrical Accessories IDV</span>
            </div>
            <div class="right-box">
              <input class="form-control" type="text" inputmode="numeric" maxlength="9"
                [(ngModel)]="electricalGoDigitBasic" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                (focusout)="getAddOnCovers('gdigit')">
            </div>
            <!-- <div class="right-box">
              <input class="form-control ml-2" type="text" inputmode="numeric" maxlength="9" [(ngModel)]="electricalHdfcBasic" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('hdfc')">
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Non Electrical Accessories IDV</span>
            </div>
            <div class="right-box">
              <input class="form-control" type="text" inputmode="numeric" maxlength="9"
                [(ngModel)]="nonElectricalGoDigitBasic" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                (focusout)="getAddOnCovers('godigit')">
            </div>
            <!-- <div class="right-box">
              <input class="form-control ml-2" type="text" inputmode="numeric" maxlength="9" [(ngModel)]="nonElectricalHdfcBasic" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('hdfc')">
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>CNG/LPG Kit IDV</span>
            </div>
            <div class="right-box">
              <input class="form-control" type="text" inputmode="numeric" [(ngModel)]="goDigitCngLpgBasic" maxlength="9"
                pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('godigit')">
            </div>
            <!-- <div class="right-box">
              <input class="form-control ml-2" type="text" inputmode="numeric" [(ngModel)]="hdfcCngLpgBasic" maxlength="9" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('hdfc')">
            </div> -->
          </div>
          <hr>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <p class="title">Add-Ons Covers</p>
            </div>
            <div class="right-box">
              <span><b>Go Digit</b></span>
            </div>
            <!-- <div class="right-box">
              <span><b>HDFC ERGO</b></span>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Parts Depreciation Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Engine And Gear Box ProtectionCover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Consumable Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Breakdown Assistance Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Return To Invoice Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Rim Damage Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Tyre Protect Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Daily conveyance</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
        
          <div class="note">
            <p>NOTE : THESE ARE INDICATIVE PRICES. INSURANCE IS THE SUBJECT
              MATTER OF SOLICITATION.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="quote-summary">
    <div class="insurer-logo">
      <span>Essential</span>
      <div class="logo-links text-center">
        <input type="radio" class="form-check-input" name="insurerLogoEssential" value="goDigit"
          (change)="onInsurerSelect($event.target.value)" checked="checked"><img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/go-digit-insurance.png">
        <!-- <input type="radio" class="form-check-input" name="insurerLogoEssential" value="hdfc" (change)="onInsurerSelect($event.target.value)" checked="checked"><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/HDFC-ERGO.png"> -->
      </div>
      <span class="text-muted">Basic Cover + Zero Depreciation</span>
    </div>
    <div class="premium-details">
      <div class="text-center">
        <div class="p-2 mr-auto">
          <span class="title">Total Premium</span>
          <span class="sub-title"> (INR,Excluding Taxes)</span>
        </div>
        <!-- <div class="p-2">
          <span class="rupees-symbol">&#8377;</span><span class="amount"></span>
        </div> -->
      </div>
      <div class="premium-amount row text-center mb-3">
        <div class="col">
          <!-- <span *ngIf="goDigitNotAvailable" class="amount">N/A</span> -->
          <span class="rupees-symbol">&#8377;</span><span
            class="amount">{{goDigitData == null ? 'NA' : goDigitPremium.option1}}</span>
        </div>
        <!-- uncomment for enable hdfc  -->
        <!-- <div class="col">
            <span *ngIf="notAvailable" class="amount">N/A</span>
            <span class="rupees-symbol">&#8377;</span><span class="amount">{{hdfcData == null ? 'NA' : hdfcPremium.option1}}</span>
          </div> -->
      </div>
      <div class="row">
        <div class="col">
          <div class="col p-2 text-center d-flex">
            <button class="btn-bordered-blue mr-auto collapsed" data-toggle="collapse"
              data-target="#detailed-section-second">
              <span class="if-collapsed"></span>
            </button>
            <button class="btn-filled-orange pull-right" (click)="goToProposal(insurerValue, '1');">Buy
              Now</button>
          </div>
        </div>
      </div>
      <div id="detailed-section-second" class="collapse">
        <div class="quote-section">
          <div class="premium-summary p-2">
            <p class="title">
              Insured declared Value (IDV) <span class="insuredAmount"> &#8377;
                {{goDigitData == null  ? 'NA' : goDigitIdvRange.minSumInsured}} -
                {{goDigitData == null  ? 'NA' : goDigitIdvRange.maxSumInsured}}</span>
            </p>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <p class="title">Covers</p>
            </div>
            <div class="right-box">
              <span><b>Go Digit</b></span>
            </div>
            <!-- <div class="right-box">
              <span><b>HDFC ERGO</b></span>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Third Party Liability</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="right"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Own Damage Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="right"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Other Driver Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="right"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>PA Unnamed Person Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>PA Owner Driver Cover (Mandatory)</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <!-- <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No Co-Pay</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <div class="right-box">
                <icon class="cross"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No sub-limits on room rent</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <div class="right-box">
                <icon class="cross"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Lower waiting period for pre-existing diseases (i.e. less than 4 years)</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <div class="right-box">
                <icon class="cross"></icon>
            </div>
          </div> -->
          <hr>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <p class="title">Accessories</p>
            </div>
            <div class="right-box">
              <span><b>Go Digit</b></span>
            </div>
            <!-- <div class="right-box">
              <span><b>HDFC ERGO</b></span>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Electrical Accessories IDV</span>
            </div>
            <div class="right-box">
              <input class="form-control" type="text" inputmode="numeric" maxlength="9"
                [(ngModel)]="electricalGoDigitEssential" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                (focusout)="getAddOnCovers('godigit')">
            </div>
            <!-- <div class="right-box">
              <input class="form-control ml-2" type="text" inputmode="numeric" maxlength="9" [(ngModel)]="electricalHdfcEssential" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('hdfc')">
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Non Electrical Accessories IDV</span>
            </div>
            <div class="right-box">
              <input class="form-control" type="text" inputmode="numeric" maxlength="9"
                [(ngModel)]="nonElectricalGoDigitEssential" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                (focusout)="getAddOnCovers('godigit')">
            </div>
            <!-- <div class="right-box">
              <input class="form-control ml-2" type="text" inputmode="numeric" maxlength="9" [(ngModel)]="nonElectricalHdfcEssential" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('hdfc')">
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>CNG/LPG Kit IDV</span>
            </div>
            <div class="right-box">
              <input class="form-control" type="text" inputmode="numeric" [(ngModel)]="goDigitCngLpgEssential"
                maxlength="9" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('godigit')">
            </div>
            <!-- <div class="right-box">
              <input class="form-control ml-2" type="text" inputmode="numeric" [(ngModel)]="hdfcCngLpgEssential" maxlength="9" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('hdfc')">
            </div> -->
          </div>
          <hr>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <p class="title">Add-Ons Covers</p>
            </div>
            <div class="right-box">
              <span><b>Go Digit</b></span>
            </div>
            <!-- <div class="right-box">
              <span><b>HDFC ERGO</b></span>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Parts Depreciation Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Engine And Gear Box ProtectionCover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Consumable Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Breakdown Assistance Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Return To Invoice Cover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Rim Damage Cover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Tyre Protect Cover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Daily conveyance</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="note">
            <p>NOTE : THESE ARE INDICATIVE PRICES. INSURANCE IS THE SUBJECT
              MATTER OF SOLICITATION.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="quote-summary">
    <div class="insurer-logo">
      <span>Basic Cover</span>
      <div class="logo-links text-center">
        <input type="radio" class="form-check-input" name="insurerLogoComprehensive" value="goDigit"
          (change)="onInsurerSelect($event.target.value)" checked="checked"><img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/go-digit-insurance.png">
        <!-- <input type="radio" class="form-check-input" name="insurerLogoComprehensive" value="hdfc" (change)="onInsurerSelect($event.target.value)" checked="checked"><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/HDFC-ERGO.png"> -->
      </div>
      <span class="text-muted">Basic Cover + Zero Depreciation + Return to Invoice</span>
    </div>
    <div class="premium-details">
      <div class="text-center">
        <div class="p-2 mr-auto">
          <span class="title">Total Premium</span>
          <span class="sub-title"> (INR,Excluding Taxes)</span>
        </div>
        <!-- <div class="p-2">
          <span class="rupees-symbol">&#8377;</span><span class="amount"></span>
        </div> -->
      </div>
      <div class="premium-amount row text-center mb-3">
        <div class="col">
          <!-- <span *ngIf="goDigitNotAvailable" class="amount">N/A</span> -->
          <span class="rupees-symbol">&#8377;</span><span
            class="amount">{{goDigitData == null ? 'NA' : goDigitPremium.option2}}</span>
        </div>
        <!-- Uncomment for Enable HDFC -->
        <!-- <div class="col">
            <span  class="rupees-symbol">&#8377;</span><span class="amount">{{hdfcData == null ? 'NA' : hdfcPremium.option2}}</span>
            <span *ngIf="notAvailable" class="amount">N/A</span>
          </div> -->
      </div>
      <div class="row">
        <div class="col">
          <div class="col p-2 text-center d-flex">
            <button class="btn-bordered-blue mr-auto collapsed" data-toggle="collapse"
              data-target="#detailed-section-third">
              <span class="if-collapsed"></span>
            </button>
            <button class="btn-filled-orange pull-right" (click)="goToProposal(insurerValue, '2');">Buy
              Now</button>
          </div>
        </div>
      </div>
      <div id="detailed-section-third" class="collapse">
        <div class="quote-section">
          <div class="premium-summary p-2">
            <p class="title">
              Insured declared Value (IDV) <span class="insuredAmount"> &#8377;
                {{goDigitData == null  ? 'NA' : goDigitIdvRange.minSumInsured}} -
                {{goDigitData == null  ? 'NA' : goDigitIdvRange.maxSumInsured}}</span>
            </p>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <p class="title">Covers</p>
            </div>
            <div class="right-box">
              <span><b>Go Digit</b></span>
            </div>
            <!-- <div class="right-box">
              <span><b>HDFC ERGO</b></span>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Third Party Liability</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="right"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Own Damage Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="right"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Other Driver Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="right"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>PA Unnamed Person Cover</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
            
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>PA Owner Driver Cover (Mandatory)</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <hr>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <p class="title">Accessories</p>
            </div>
            <div class="right-box">
              <span><b>Go Digit</b></span>
            </div>
            <!-- <div class="right-box">
              <span><b>HDFC ERGO</b></span>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Electrical Accessories IDV</span>
            </div>
            <div class="right-box">
              <input class="form-control" type="text" inputmode="numeric" maxlength="9"
                [(ngModel)]="electricalGoDigitComprehensive" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                (focusout)="getAddOnCovers('godigit')">
            </div>
            <!-- <div class="right-box">
              <input class="form-control ml-2" type="text" inputmode="numeric" maxlength="9" [(ngModel)]="electricalHdfcComprehensive" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('hdfc')">
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Non Electrical Accessories IDV</span>
            </div>
            <div class="right-box">
              <input class="form-control" type="text" inputmode="numeric" maxlength="9"
                [(ngModel)]="nonElectricalGoDigitComprehensive" pattern="^((?!(0))[0-9]{1,10}\d*)$"
                (focusout)="getAddOnCovers('godigit')">
            </div>
            <!-- <div class="right-box">
              <input class="form-control ml-2" type="text" inputmode="numeric" maxlength="9" [(ngModel)]="nonElectricalHdfcComprehensive" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('hdfc')">
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>CNG/LPG Kit IDV</span>
            </div>
            <div class="right-box">
              <input class="form-control" type="text" inputmode="numeric" [(ngModel)]="goDigitCngLpgComprehensive"
                maxlength="9" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('godigit')">
            </div>
            <!-- <div class="right-box">
              <input class="form-control ml-2" type="text" inputmode="numeric" [(ngModel)]="hdfcCngLpgComprehensive" maxlength="9" pattern="^((?!(0))[0-9]{1,10}\d*)$" (focusout)="getAddOnCovers('hdfc')">
            </div> -->
          </div>
          <hr>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <p class="title">Add-Ons Covers</p>
            </div>
            <div class="right-box">
              <span><b>Go Digit</b></span>
            </div>
            <!-- <div class="right-box">
              <span><b>HDFC ERGO</b></span>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Parts Depreciation Cover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Engine And Gear Box ProtectionCover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Consumable Cover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Breakdown Assistance Cover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Return To Invoice Cover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Rim Damage Cover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Tyre Protect Cover</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Daily conveyance</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
            <!-- <div class="right-box">
                <icon class="cross"></icon>
            </div> -->
          </div>
          <div class="note">
            <p>NOTE : THESE ARE INDICATIVE PRICES. INSURANCE IS THE SUBJECT
              MATTER OF SOLICITATION.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="motor-proposal-details"
  *ngIf="!quotesDetailsTable && motorProposalPageHdfc && !motorProposalPageGodigit">
  <form name="form" (ngSubmit)="personalForm.form.valid" #personalForm="ngForm">
    <div class="">
      <!-- Nav pills -->
      <ul class="nav nav-pills justify-content-center" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="pill" href="#details" [ngClass]="{ 'active':activeTab==='details'}"
            (click)="details('details')">Proposer's Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="pill" href="#vehicle" [ngClass]="{ 'active':activeTab==='vehicle'}"
            data-toggle="tab" (click)="vehicle('vehicle')">Vehicle's Details</a>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content">

        <div id="details" class="container tab-pane active" [ngClass]="{ 'active':activeTab==='details'}"><br>
          <div class="row">
            <div class="col-2" style="padding-right:0px;">
              <p class="title mendatory">Title</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <select class="form-control" name="title" [(ngModel)]="f.title" id="title" #title="ngModel" required>
                    <option value="MALE">Mr</option>
                    <option value="FEMALE">Ms</option>
                  </select>
                  <div *ngIf="title.invalid && title.touched " class="error-message">
                    <div *ngIf="title.errors.required">
                      Title is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-5">
              <p class="title mendatory">First Name</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="fName" [(ngModel)]="f.firstName" id="fName"
                    #fName="ngModel" pattern="[a-zA-Z]+" maxlength="200" required>
                  <div *ngIf="fName.invalid && fName.touched " class="error-message">
                    <div *ngIf="fName.errors.required">
                      First Name is required.
                    </div>
                    <div *ngIf="fName.errors.pattern">
                      Please enter valid First name.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-5">
              <p class="title mendatory">Last Name</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="lName" [(ngModel)]="f.lastName" id="lName"
                    #lName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                  <div *ngIf="lName.invalid && lName.touched " class="error-message">
                    <div *ngIf="lName.errors.required">
                      Last Name is required.
                    </div>
                    <div *ngIf="lName.errors.pattern">
                      Please enter valid Last name.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Mobile No.</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input type="text" #mobile="ngModel" name="mobile" id="mobile" class="form-control"
                    [(ngModel)]="f.mobile" #mobile1="ngModel" maxlength="10" minlength="10"
                    (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric"
                    required>
                  <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
                    <div *ngIf="mobile.errors.required">
                      Mobile number is required.
                    </div>
                    <div *ngIf="mobile.errors.maxlength">
                      Mobile number should not be greater than 10 digits.
                    </div>
                    <div *ngIf="mobile.errors.minlength">
                      Mobile number must be at least 10 digits long.
                    </div>
                    <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                      Invalid mobile number.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">E-mail Address</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="email" name="email" id="email" #email="ngModel"
                    [(ngModel)]="f.email" [email]="true" maxlength="100" required>
                  <div *ngIf="email.invalid && email.touched " class="error-message">
                    <div *ngIf="email.errors.required">
                      Email Address is required.
                    </div>
                    <div *ngIf="email.errors.email">
                      Please enter correct Email address.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <p class="title mendatory">Date of Birth</p>
              <div class="sum-insured-input reg-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img
                      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposalDob" dateFormat="dd/mm/yy"
                      [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2020" placeholder="Date" name="dob"
                      [maxDate]="currentDate" keepInvalid [required]="true"></p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="shouldBe18" class="error-message">
                  Date of birth should be greater than 18.
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Date of Birth is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Occupation</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <select class="form-control long-text" id="insuredOccupation" name="occupation"
                    [(ngModel)]="f.occupation" id="occupation" #occupation="ngModel"
                    (change)="getSelectedOccupation($event)" required>
                    <option value="1">Practicing Chartered Accountant</option>
                    <option value="2">Defense and Para Military Service</option>
                    <option value="3">Teacher in Govt. recognized Institutions</option>
                    <option value="4">Central / State Government Employees</option>
                    <option value="5">Doctors registered with Government</option>
                    <option value="0">Others</option>
                  </select>
                  <div *ngIf="occupation.invalid && occupation.touched " class="error-message">
                    <div *ngIf="occupation.errors.required">
                      Occupation is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Designation</p>
              <div class="form-group">
                <input class="form-control" id="designation" name="designation" [(ngModel)]="f.designation"
                  #designation="ngModel" required>
                <!-- <select class="form-control long-text" id="designation" name="designation" [(ngModel)]="f.designation" #designation="ngModel" required>
                      <option>ALLOPATHY</option>
                      <option>AYURVEDA</option>
                      <option>HOMEPATHY</option>
                      <option>ANY OTHER</option>
                    </select> -->
                <div *ngIf="designation.invalid && designation.touched " class="error-message">
                  <div *ngIf="designation.errors.required">
                    Please select Designation.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <p class="title mendatory">Annual Income</p>
              <div class="form-group">
                <select class="form-control long-text" id="annualIncome" name="annualIncome"
                  [(ngModel)]="f.annualIncome" #annualIncome="ngModel" required>
                  <option value="Less than Rs 5 Lacs">Less than Rs 5 Lacs</option>
                  <option value="Rs 5 to 15 Lacs">Rs 5 to 15 Lacs</option>
                  <option value="More than Rs 15 Lacs">More than Rs 15 Lacs</option>
                </select>
                <div *ngIf="annualIncome.invalid && annualIncome.touched " class="error-message">
                  <div *ngIf="annualIncome.errors.required">
                    Please select Annual Income.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Uncomment this for append lines -->
          <!-- <button (click)="addQual()">+</button>
            <div class="row" *ngFor="let qual of qualification; let i = index;">
              <div class="col-8">
                <p class="title mendatory">All Professional Qualification {{i+1}}</p>
                <div class="form-group">
                  <input class="form-control" type="text" name="qualification_{{i+1}}" [(ngModel)]="f.qualification_{{i+1}}" id="qualification_{{i+1}}" #qualification="ngModel" maxlength="200" required>
                  <div *ngIf="qualification.invalid && qualification.touched " class="error-message">
                    <div *ngIf="qualification.errors.required">
                      Professional Qualification is required.
                    </div>
                  </div>
              </div>
            </div> -->
          <!-- Uncomment this for append lines -->
          <div class="row">
            <div class="col-6">
              <p class="title">PAN Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="pan" #pan="ngModel" [(ngModel)]="f.pan"
                    pattern="^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$">
                  <div *ngIf="pan.invalid && pan.touched " class="error-message">
                    <div *ngIf="pan.errors.pattern">
                      Please enter valid PAN number.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <p class="title">Aadhaar Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="adhaar" #adhaar="ngModel"
                    [(ngModel)]="personalForm.adhaar" pattern="^\d{4}\d{4}\d{4}$">
                  <div *ngIf="adhaar.invalid && adhaar.touched " class="error-message">
                    <div *ngIf="adhaar.errors.pattern">
                      Please enter valid Aadhar number.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Residential Address</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <textarea class="form-control" rows="3" name="address1" [(ngModel)]="f.address1" id="address1"
                    #address1="ngModel" maxlength="500" required></textarea>
                  <div *ngIf="address1.invalid && address1.touched " class="error-message">
                    <div *ngIf="address1.errors.required">
                      Address is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Pin Code</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="number" name="pinCode" [(ngModel)]="f.pincode"
                    (keydown.space)="$event.preventDefault();" (focusout)="getCityStateList(f.pincode)" maxlength="6"
                    minlength="6" id="pinCode" #pinCode="ngModel"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    required>
                  <div *ngIf="invalidPincode" class="error-message">
                    Invalid pincode.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">City</p>
              <div class="sum-insured-input form-group">
                <select name="city" class="form-control quote-dropdown" id="city" name="city" [(ngModel)]="f.city"
                  #city="ngModel" required>
                  <option *ngFor="let city of cityList" value="{{city}}">{{city | uppercase}}</option>
                </select>
                <div *ngIf="city.invalid && city.touched " class="error-message">
                  <div *ngIf="city.errors.required">
                    City is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">State</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="stateList" [(ngModel)]="f.state" disabled>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Area</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="area" [(ngModel)]="f.area">
                </div>
              </div>
            </div>
          </div>



          <div class="row mt-4">
            <div class="col-6 text-right">
              <button class="btn btn-bordered-blue" (click)="saveProposalHdfc();">Save</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-bordered-blue" (click)="details('vehicle')">Next</button>
            </div>
            <!-- <div class="col-12 text-center">
                <button class="btn btn-bordered-blue" (click)="openModal(template);getProposalService(f);" [disabled]="personalForm.form.invalid" id="proceedPayment">Proceed</button>
              </div> -->
          </div>
        </div>
        <div id="vehicle" class="container tab-pane vehicle-section" [ngClass]="{ 'active':activeTab==='vehicle'}"><br>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Vehicle Registration Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input type="text" #vehicleRegNum="ngModel" name="vehicleRegNum" id="vehicleRegNum"
                    class="form-control" [(ngModel)]="vehicleRegNumLead" maxlength="100" placeholder="Ex; HR26AC1234"
                    required>
                  <div *ngIf="vehicleRegNum.invalid && vehicleRegNum.touched" class="error-message">
                    <div *ngIf="vehicleRegNum.errors.required">
                      Vehicle Registration number is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Engine Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="engineNumber" id="engineNumber" #engineNumber="ngModel"
                    [(ngModel)]="engineNumberLead" minlength="5" maxlength="100" required>
                  <div *ngIf="engineNumber.invalid && engineNumber.touched " class="error-message">
                    <div *ngIf="engineNumber.errors.required">
                      Engine Number is required.
                    </div>
                    <div *ngIf="engineNumber.errors.minlength">
                      Engine number should contain atleast 5 characters.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Chasis Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="chasisNumber" id="chasisNumber" #chasisNumber="ngModel"
                    [(ngModel)]="chasisNumberLead" maxlength="100" required>
                  <div *ngIf="chasisNumber.invalid && chasisNumber.touched " class="error-message">
                    <div *ngIf="chasisNumber.errors.required">
                      Chasis Number is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <p class="title mendatory">Manufacturing Date</p>
              <div class="sum-insured-input reg-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img
                      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="manufaturingDateLead"
                      dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2200"
                      placeholder="Date" name="manufaturingDate" [minDate]="startDate" keepInvalid [required]="true">
                    </p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Manufaturing Date is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Manufacturer</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="manufacturer" id="manufacturer" #manufacturer="ngModel"
                    [(ngModel)]="f.manufacturer" maxlength="100" required>
                  <div *ngIf="manufacturer.invalid && manufacturer.touched " class="error-message">
                    <div *ngIf="manufacturer.errors.required">
                      Manufacturer is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Car Model</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="carModel" id="carModel" #carModel="ngModel"
                    [(ngModel)]="f.carModel" maxlength="100" required>
                  <div *ngIf="carModel.invalid && carModel.touched " class="error-message">
                    <div *ngIf="carModel.errors.required">
                      Car Model is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Fuel Type</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <select class="form-control long-text" id="fuel" name="fuel" [(ngModel)]="personalForm.fuel" id="fuel"
                    #fuel="ngModel" required>
                    <option value="PETROL">Petrol</option>
                    <option value="DIESEL">Diesel</option>
                  </select>
                  <div *ngIf="occupation.invalid && occupation.touched " class="error-message">
                    <div *ngIf="occupation.errors.required">
                      Fuel Type is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <p class="title mendatory">Purchasing Registration Date</p>
              <div class="sum-insured-input reg-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img
                      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="purchaseDateLead"
                      dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2200"
                      placeholder="Date" name="purchaseDate" [maxDate]="personalForm.manufaturingDate" keepInvalid
                      [required]="true"></p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Purchase Date Date is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row from-group justify-content-center pt-3">
            <div class="col-9 age-input">
              <div class="input-group">
                <input type="text" id="age" name="age" class="form-control" placeholder="Enter OTP" #age="ngModel"
                  [(ngModel)]="personalForm.otp" maxlength="4" (keydown.space)="$event.preventDefault();"
                  pattern="[0-9]*" inputmode="numeric" required>
                <div class="input-group-append send-input-group-append otp-input-append" *ngIf="!verifyOtpBtn">
                  <button class="btn btn-input-arrow" id="sendOtp" type="submit" (click)="sendOtpFunc()"></button>
                </div>
                <div class="input-group-append verify-input-group-append otp-input-append" *ngIf="verifyOtpBtn">
                  <button class="btn btn-input-arrow" id="verifyOtp" type="submit"
                    (click)="verifyOtpFunc(personalForm.otp)"></button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5" *ngIf="!otpVerified">
            <div class="col-12 text-center">
              <button class="btn btn-bordered-blue" (click)="saveProposalHdfc();">Save</button>
            </div>
          </div>
          <div class="row mt-5" *ngIf="otpVerified">
            <div class="col-6 text-right">
              <button class="btn btn-bordered-blue" (click)="saveProposalHdfc();">Save</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-bordered-blue" (click)="openModal(template);"
                [disabled]="personalForm.form.invalid">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span id="snackbar"></span>
  </form>
</section>
<section class="motor-proposal-details"
  *ngIf="!quotesDetailsTable && motorProposalPageGodigit && !motorProposalPageHdfc">
  <form name="form" (ngSubmit)="personalForm.form.valid" #personalForm="ngForm">
    <div class="">
      <!-- Nav pills -->
      <ul class="nav nav-pills justify-content-center" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="pill" href="#details" [ngClass]="{ 'active':activeTab==='details'}"
            (click)="details('details')">Proposer's Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="pill" href="#vehicle" [ngClass]="{ 'active':activeTab==='vehicle'}"
            data-toggle="tab" (click)="vehicle('vehicle')">Vehicle's Details</a>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content">

        <div id="details" class="container tab-pane active" [ngClass]="{ 'active':activeTab==='details'}"><br>
          <div class="row">
            <div class="col-2" style="padding-right:0px;">
              <p class="title mendatory">Title</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <select class="form-control" name="title" [(ngModel)]="f.title" id="title" #title="ngModel" required>
                    <option value="MALE">Mr</option>
                    <option value="FEMALE">Ms</option>
                  </select>
                  <div *ngIf="title.invalid && title.touched " class="error-message">
                    <div *ngIf="title.errors.required">
                      Title is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-5">
              <p class="title mendatory">First Name</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="fName" [(ngModel)]="f.firstName" id="fName"
                    #fName="ngModel" pattern="[a-zA-Z]+" maxlength="200" required>
                  <div *ngIf="fName.invalid && fName.touched " class="error-message">
                    <div *ngIf="fName.errors.required">
                      First Name is required.
                    </div>
                    <div *ngIf="fName.errors.pattern">
                      Please enter valid First name.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-5">
              <p class="title mendatory">Last Name</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="lName" [(ngModel)]="f.lastName" id="lName"
                    #lName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                  <div *ngIf="lName.invalid && lName.touched " class="error-message">
                    <div *ngIf="lName.errors.required">
                      Last Name is required.
                    </div>
                    <div *ngIf="lName.errors.pattern">
                      Please enter valid Last name.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Mobile No.</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input type="text" #mobile="ngModel" name="mobile" id="mobile" class="form-control"
                    [(ngModel)]="f.mobile" #mobile1="ngModel" maxlength="10" minlength="10"
                    (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric"
                    required>
                  <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
                    <div *ngIf="mobile.errors.required">
                      Mobile number is required.
                    </div>
                    <div *ngIf="mobile.errors.maxlength">
                      Mobile number should not be greater than 10 digits.
                    </div>
                    <div *ngIf="mobile.errors.minlength">
                      Mobile number must be at least 10 digits long.
                    </div>
                    <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                      Invalid mobile number.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">E-mail Address</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="email" name="email" id="email" #email="ngModel"
                    [(ngModel)]="f.email" [email]="true" maxlength="100" required>
                  <div *ngIf="email.invalid && email.touched " class="error-message">
                    <div *ngIf="email.errors.required">
                      Email Address is required.
                    </div>
                    <div *ngIf="email.errors.email">
                      Please enter correct Email address.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <p class="title mendatory">Date of Birth</p>
              <div class="sum-insured-input reg-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img
                      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="proposalDob" dateFormat="dd/mm/yy"
                      [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2020" placeholder="Date" name="dob"
                      [maxDate]="currentDate" keepInvalid [required]="true"></p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="shouldBe18" class="error-message">
                  Date of birth should be greater than 18.
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Date of Birth is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Occupation</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <select class="form-control long-text" id="insuredOccupation" name="occupation"
                    [(ngModel)]="f.occupation" id="occupation" #occupation="ngModel"
                    (change)="getSelectedOccupation($event)" required>
                    <option value="1">Practicing Chartered Accountant</option>
                    <option value="2">Defense and Para Military Service</option>
                    <option value="3">Teacher in Govt. recognized Institutions</option>
                    <option value="4">Central / State Government Employees</option>
                    <option value="5">Doctors registered with Government</option>
                    <option value="0">Others</option>
                  </select>
                  <div *ngIf="occupation.invalid && occupation.touched " class="error-message">
                    <div *ngIf="occupation.errors.required">
                      Occupation is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Designation</p>
              <div class="form-group">
                <input class="form-control" id="designation" name="designation" [(ngModel)]="f.designation"
                  #designation="ngModel" required>
                <!-- <select class="form-control long-text" id="designation" name="designation" [(ngModel)]="f.designation" #designation="ngModel" required>
                      <option>ALLOPATHY</option>
                      <option>AYURVEDA</option>
                      <option>HOMEPATHY</option>
                      <option>ANY OTHER</option>
                    </select> -->
                <div *ngIf="designation.invalid && designation.touched " class="error-message">
                  <div *ngIf="designation.errors.required">
                    Please select Designation.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <p class="title mendatory">Annual Income</p>
              <div class="form-group">
                <select class="form-control long-text" id="annualIncome" name="annualIncome"
                  [(ngModel)]="f.annualIncome" #annualIncome="ngModel" required>
                  <option value="Less than Rs 5 Lacs">Less than Rs 5 Lacs</option>
                  <option value="Rs 5 to 15 Lacs">Rs 5 to 15 Lacs</option>
                  <option value="More than Rs 15 Lacs">More than Rs 15 Lacs</option>
                </select>
                <div *ngIf="annualIncome.invalid && annualIncome.touched " class="error-message">
                  <div *ngIf="annualIncome.errors.required">
                    Please select Annual Income.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Uncomment this for append lines -->
          <!-- <button (click)="addQual()">+</button>
            <div class="row" *ngFor="let qual of qualification; let i = index;">
              <div class="col-8">
                <p class="title mendatory">All Professional Qualification {{i+1}}</p>
                <div class="form-group">
                  <input class="form-control" type="text" name="qualification_{{i+1}}" [(ngModel)]="f.qualification_{{i+1}}" id="qualification_{{i+1}}" #qualification="ngModel" maxlength="200" required>
                  <div *ngIf="qualification.invalid && qualification.touched " class="error-message">
                    <div *ngIf="qualification.errors.required">
                      Professional Qualification is required.
                    </div>
                  </div>
              </div>
            </div> -->
          <!-- Uncomment this for append lines -->
          <div class="row">
            <div class="col-6">
              <p class="title">PAN Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="pan" #pan="ngModel" [(ngModel)]="f.pan"
                    pattern="^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$">
                  <div *ngIf="pan.invalid && pan.touched " class="error-message">
                    <div *ngIf="pan.errors.pattern">
                      Please enter valid PAN number.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <p class="title">Aadhaar Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="adhaar" #adhaar="ngModel"
                    [(ngModel)]="personalForm.adhaar" pattern="^\d{4}\d{4}\d{4}$">
                  <div *ngIf="adhaar.invalid && adhaar.touched " class="error-message">
                    <div *ngIf="adhaar.errors.pattern">
                      Please enter valid Aadhar number.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Flat Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input type="number" class="form-control" name="address1" [(ngModel)]="f.address1" id="address1"
                    #address1="ngModel" maxlength="500" pattern="[0-9]*" inputmode="numeric" required>
                  <div *ngIf="address1.invalid && address1.touched " class="error-message">
                    <div *ngIf="address1.errors.required">
                      Address is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Street</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input type="text" class="form-control" name="address2" [(ngModel)]="f.address2" id="address2"
                    #address2="ngModel" maxlength="500" required>
                  <div *ngIf="address2.invalid && address2.touched " class="error-message">
                    <div *ngIf="address2.errors.required">
                      Address is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Pin Code</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="number" name="pinCode" [(ngModel)]="f.pincode"
                    (keydown.space)="$event.preventDefault();" (focusout)="goDigitPincodeValidate(f.pincode)"
                    maxlength="6" minlength="6" id="pinCode" #pinCode="ngModel"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    required>
                  <div *ngIf="invalidPincode" class="error-message">
                    Invalid pincode.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Area</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <!-- <input class="form-control" type="text" name="area" [(ngModel)]="f.area" > -->
                  <select name="city" class="form-control quote-dropdown" id="area" name="area" [(ngModel)]="f.area"
                    #area="ngModel" required>
                    <option *ngFor="let area of areaList" value="{{area}}">{{area | uppercase}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">City</p>
              <div class="form-group">
                <!-- <select name="city" class="form-control quote-dropdown" id="city" name="city" [(ngModel)]="f.city" #city="ngModel" required>
                    <option *ngFor="let city of cityList" value="{{city}}" >{{city | uppercase}}</option>
                  </select>
                  <div *ngIf="city.invalid && city.touched " class="error-message">
                    <div *ngIf="city.errors.required">
                        City is required.
                    </div>
                  </div> -->
                <input class="form-control" type="text" name="city" [(ngModel)]="f.city" disabled>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">State</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="stateList" [(ngModel)]="f.state" disabled>
                </div>
              </div>
            </div>
          </div>




          <div class="row mt-4">
            <div class="col-6 text-right">
              <button class="btn btn-bordered-blue" (click)="saveProposalGodigit();">Save</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-bordered-blue" (click)="details('vehicle')">Next</button>
            </div>
            <!-- <div class="col-12 text-center">
                <button class="btn btn-bordered-blue" (click)="openModal(template);getProposalService(f);" [disabled]="personalForm.form.invalid" id="proceedPayment">Proceed</button>
              </div> -->
          </div>
        </div>
        <div id="vehicle" class="container tab-pane vehicle-section" [ngClass]="{ 'active':activeTab==='vehicle'}"><br>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Vehicle Registration Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input type="text" #vehicleRegNum="ngModel" name="vehicleRegNum" id="vehicleRegNum"
                    class="form-control" [(ngModel)]="vehicleRegNumLead" placeholder="Ex; HR26AC1234" maxlength="100"
                    required>
                  <div *ngIf="vehicleRegNum.invalid && vehicleRegNum.touched" class="error-message">
                    <div *ngIf="vehicleRegNum.errors.required">
                      Vehicle Registration number is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Engine Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="engineNumber" id="engineNumber" #engineNumber="ngModel"
                    [(ngModel)]="engineNumberLead" minlength="5" maxlength="100" required>
                  <div *ngIf="engineNumber.invalid && engineNumber.touched " class="error-message">
                    <div *ngIf="engineNumber.errors.required">
                      Engine Number is required.
                    </div>
                    <div *ngIf="engineNumber.errors.minlength">
                      Engine number should contain atleast 5 characters.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Chasis Number</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="chasisNumber" id="chasisNumber" #chasisNumber="ngModel"
                    [(ngModel)]="chasisNumberLead" pattern="^[a-zA-Z0-9]{17,}$" maxlength="100" required>
                  <div *ngIf="chasisNumber.invalid && chasisNumber.touched " class="error-message">
                    <div *ngIf="chasisNumber.errors.required">
                      Chasis Number is required.
                    </div>
                    <div *ngIf="chasisNumber.errors.pattern">
                      Vehicle Chassis number must have minimum 17 characters and must be alphanumeric.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <p class="title mendatory">Manufacturing Date</p>
              <div class="sum-insured-input reg-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img
                      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="manufaturingDateLead"
                      dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2200"
                      placeholder="Date" name="manufaturingDate" [minDate]="startDate" keepInvalid [required]="true">
                    </p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Manufaturing Date is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Manufacturer</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="manufacturer" id="manufacturer" #manufacturer="ngModel"
                    [(ngModel)]="f.manufacturer" maxlength="100" required>
                  <div *ngIf="manufacturer.invalid && manufacturer.touched " class="error-message">
                    <div *ngIf="manufacturer.errors.required">
                      Manufacturer is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Car Model</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <input class="form-control" type="text" name="carModel" id="carModel" #carModel="ngModel"
                    [(ngModel)]="f.carModel" maxlength="100" required>
                  <div *ngIf="carModel.invalid && carModel.touched " class="error-message">
                    <div *ngIf="carModel.errors.required">
                      Car Model is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="title mendatory">Fuel Type</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <select class="form-control long-text" id="fuel" name="fuel" [(ngModel)]="personalForm.fuel" id="fuel"
                    #fuel="ngModel" required>
                    <option value="PETROL">Petrol</option>
                    <option value="DIESEL">Diesel</option>
                  </select>
                  <div *ngIf="occupation.invalid && occupation.touched " class="error-message">
                    <div *ngIf="occupation.errors.required">
                      Fuel Type is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <p class="title mendatory">Purchasing Registration Date</p>
              <div class="sum-insured-input reg-date-input">
                <div class="input-group">
                  <div class="input-group addon">
                    <img
                      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                    <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="purchaseDateLead"
                      dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2200"
                      placeholder="Date" name="purchaseDate" [maxDate]="personalForm.manufaturingDate" keepInvalid
                      [required]="true"></p-calendar>
                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                  </div>
                </div>
                <div *ngIf="DOBrequired" class="error-message">
                  Purchase Date Date is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="newBusinessType">
            <div class="col-12">
              <p class="title mendatory">Sub Insurance Product</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <select class="form-control long-text" id="subInsurance" name="subInsurance"
                    [(ngModel)]="subInsuranceOnLead" id="subInsurance" #subInsurance="ngModel"
                    (change)="getSubInsurer($event)" required>
                    <!-- <option value="30">3 Year TP + 0 Year OD</option> -->
                    <option value="31">3 Year TP + 1 Year OD</option>
                    <option value="33">3 Year TP + 3 Year OD</option>
                  </select>
                  <div *ngIf="subInsurance.invalid && subInsurance.touched " class="error-message">
                    <div *ngIf="subInsurance.errors.required">
                      Sub Insurance is required.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="!newBusinessType">
            <div class="col-12">
              <p class="title mendatory">Previous Insurer</p>
              <div class="sum-insured-input">
                <div class="form-group">
                  <select class="form-control" name="previousInsurer" id="previousInsurer"
                    [(ngModel)]="personalForm.previousInsurer" #previousInsurer="ngModel"
                    (change)="getSelectedPreviousInsurer($event)" required>
                    <option disabled selected>Select Previous Insurer</option>
                    <option value="{{insurer.Code}}" *ngFor="let insurer of previousInsurerData">{{insurer.Name}}
                    </option>
                  </select>
                  <div *ngIf="previousInsurer.invalid && previousInsurer.touched " class="error-message">
                    <div *ngIf="previousInsurer.errors.required">
                      Please select Previous Insurer.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-6 text-right">
              <button class="btn btn-bordered-blue" (click)="saveProposalGodigit();">Save</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-bordered-blue"
                (click)="openModal(template);calculatePremium('godigit');"
                [disabled]="personalForm.form.invalid">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span id="snackbar"></span>
  </form>
</section>
<section class="motorProposalThankYou" *ngIf="hdfcThankyouSection">
  <div class="container">
    <div class="col">
      <h4 class="payment-title text-center mt-4">Payment Successful</h4>
      <div class="insurer-image text-center mt-4">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/HDFC-ERGO.png"
          class="img-responsive" width="50%" alt="Religare Insurance">
      </div>
    </div>
    <div class="col download-document">
      <div class="insurer-image text-center">
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/file-4.svg"
          class="img-responsive" width="20%" alt="Download Document">
      </div>
      <h4 class="download-title text-center mt-3">Download Policy Document</h4>
    </div>
    <div class="col contact-us text-center">
      <p class="title">For Endorsement and Claim Contact at:</p>
      <p class="call"><img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/phone.svg"><span>1860-500-4488</span><span
          class="bar"></span><span>1800-102-4488</span></p>
      <p class="call"><span><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/message.svg"></span>customerfirst@religarehealthinsurance.com
      </p>
    </div>
    <div class="col footer-strip text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
</section>
<section class="motorTransactionFailure" *ngIf="hdfcTransactionFailureSection">
  <div class="container">
    <div class="col text-center failure-error">

      <div class="insurer-image mt-4">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/ERROR.svg"
          class="img-responsive" width="20%" alt="Error">
      </div>
      <h4 class="payment-title mt-4">Oops... Payment Failed</h4>
      <p class="error-message">{{errorStatus}}</p>
      <p class="error-message">{{errorInternalMsg}}</p>
      <!-- <p>Transaction Id: 778W990</p> -->
    </div>
    <div class="col failure-reasons">
      <ul class="oval">
        <li>The Card CVV or Expiry Date might be wrong</li>
        <li>Your Bank networks might be down</li>
      </ul>
      <div class="text-center mt-4">
        <button class="btn btn-bordered-blue">Try Again</button>
      </div>
    </div>
    <div class="col footer-strip text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<section class="motorProposalThankYou" *ngIf="godigitThankyouSection">
  <div class="container">
    <div class="col">
      <h4 class="payment-title text-center mt-4">Payment Successful</h4>
      <div class="insurer-image text-center mt-4">
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/go-digit-insurance.png"
          class="img-responsive" width="50%" alt="Religare Insurance">
      </div>
    </div>
    <div class="col download-document">
      <div class="insurer-image text-center">
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/file-4.svg"
          class="img-responsive" width="20%" alt="Download Document">
      </div>
      <h4 class="download-title text-center mt-3">Download Policy Document</h4>
    </div>
    <div class="col contact-us text-center">
      <p class="title">For Endorsement and Claim Contact at:</p>
      <p class="call"><img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/phone.svg"><span>1860-500-4488</span><span
          class="bar"></span><span>1800-102-4488</span></p>
      <p class="call"><span><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/message.svg"></span>customerfirst@religarehealthinsurance.com
      </p>
    </div>
    <div class="col footer-strip text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
</section>
<section class="motorTransactionFailure" *ngIf="godigitTransactionFailureSection">
  <div class="container">
    <div class="col text-center failure-error">

      <div class="insurer-image mt-4">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/ERROR.svg"
          class="img-responsive" width="20%" alt="Error">
      </div>
      <h4 class="payment-title mt-4">Oops... Payment Failed</h4>
      <p class="error-message">{{errorStatus}}</p>
      <p class="error-message">{{errorInternalMsg}}</p>
      <!-- <p>Transaction Id: 778W990</p> -->
    </div>
    <div class="col failure-reasons">
      <ul class="oval">
        <li>The Card CVV or Expiry Date might be wrong</li>
        <li>Your Bank networks might be down</li>
      </ul>
      <div class="text-center mt-4">
        <button class="btn btn-bordered-blue">Try Again</button>
      </div>
    </div>
    <div class="col footer-strip text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<ng-template #template>
  <form name="form" (ngSubmit)="terms.form.valid" #terms="ngForm">
    <div class="modal-body">
      <div class="col">
        <h4 class="modal-title">Terms & Conditions</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="col mt-4">
        <div class="checkbox">
          <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="terms.termCheck"
              #termCheck="ngModel" required> Receive Service SMS and E-mail alerts</label>
        </div>
        <div class="checkbox" *ngIf="!environment.production">
          <label><input type="checkbox" name="termCheck" id="termCheck2" name="termCheck2"
              [(ngModel)]="terms.termCheck2" #termCheck2="ngModel" required> I hereby agree to the <a
              href="https://pamstaging.securenow.in/blog/terms-and-conditions" target="_blank">terms & conditions</a> of
            the purchase of this policy.</label>
        </div>
        <div class="checkbox" *ngIf="environment.production">
          <label><input type="checkbox" name="termCheck" id="termCheck2" name="termCheck2"
              [(ngModel)]="terms.termCheck2" #termCheck2="ngModel" required> I hereby agree to the <a
              href="https://securenow.in/blog/terms-and-conditions/" target="_blank">terms & conditions</a> of the
            purchase of this policy.</label>
        </div>
        <div class="checkbox" *ngIf="!environment.production">
          <label><input type="checkbox" name="termCheck" id="termCheck3" name="termCheck3"
              [(ngModel)]="terms.termCheck3" #termCheck3="ngModel" required> I would also like to add Standing
            Instruction on my credit card for automatic future renewal premiums. <a
              href="https://pamstaging.securenow.in/blog/terms-and-conditions" target="_blank">Terms &
              Conditions.</a></label>
        </div>
        <div class="checkbox" *ngIf="environment.production">
          <label><input type="checkbox" name="termCheck" id="termCheck3" name="termCheck3"
              [(ngModel)]="terms.termCheck3" #termCheck3="ngModel" required> I would also like to add Standing
            Instruction on my credit card for automatic future renewal premiums. <a
              href="https://securenow.in/blog/terms-and-conditions/" target="_blank">Terms & Conditions.</a></label>
        </div>
      </div>
      <div class="col text-center mt-4">
        <button class="btn btn-bordered-blue" aria-label="Close"
          (click)="modalRef.hide();openModal(paymentSummaryTemplate);motorGoDigitGeneratePolicy();"
          [disabled]="terms.form.invalid">Proceed To Pay</button>
      </div>
    </div>
  </form>
</ng-template>
<ng-template #paymentSummaryTemplate>
  <form name="form" (ngSubmit)="payment.form.valid" #payment="ngForm">
    <div class="modal-body">
      <div class="col">
        <h4 class="modal-title">Summary Details</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="col text-center mt-4">
        <p class="title">Premium (Including taxes)</p>
        <h2 *ngIf="totalPremiumForHdfc"><span class="rupees-symbol">&#8377;</span> {{totalPremiumForHdfc}}</h2>
        <div class="row" *ngIf="totalPremiumForGoDigit">
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <p>Base Premium</p>
                <p>Service Tax</p>
              </div>
              <div class="col-6">
                <p><span class="rupees-symbol">&#8377;</span> {{totalPremiumForGoDigit}}</p>
                <p><span class="rupees-symbol">&#8377;</span> {{goDigitServiceTax}}</p>
              </div>
            </div>
          </div>
          <hr>
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <p>Total Premium</p>
              </div>
              <div class="col-6">
                <p><span class="rupees-symbol">&#8377;</span> {{totalPremiumIncludedTaxGoDigit}}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col text-center mt-4">
        <button *ngIf="totalPremiumForHdfc" class="btn btn-bordered-blue" aria-label="Close"
          (click)="modalRef.hide();getHdfcProposal();">CONFIRM AND PROCEED</button>
        <button *ngIf="totalPremiumForGoDigit" class="btn btn-bordered-blue" aria-label="Close"
          (click)="modalRef.hide(); motorInitiateToPaymentGoDigit();">CONFIRM AND PROCEED</button>
      </div>
    </div>
  </form>
</ng-template>
<ng-template #thankYou>
  <form name="form" (ngSubmit)="thankyou.form.valid" #thankyou="ngForm">
    <div class="modal-body">
      <div class="col">
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h2 class="modal-title"></h2>
      </div>
      <div class="col text-center mt-4">
        <h3>Thank You</h3>
        <p class="title">We will call you back within 24 hours.</p>
      </div>
    </div>
  </form>
</ng-template>
<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>
<div id="spinner" [hidden]="!loadingGodigit">
  <div class="spinnerfull">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>
<span id="snackbar"></span>
